<template>
  <div class="legal-texts-show-view">
    <link-button
      icon="pencil"
      :to="{ name: 'edit-legal-text',
             params: { id: legalText.id } }"
    >
      {{$t('actions.edit')}}
    </link-button>

    <common-button
      @click="deleteLegalTextWhenConfirmed"
      type="danger"
      icon="trash"
    >
      {{$t('actions.delete')}}
    </common-button>

    <h3>{{$t('fieldsets.basicFields')}}</h3>
    <attribute-table
      :data="legalText"
      :fields="['name', 'insertedAt', 'updatedAt']"
    >
      <template slot="name" scope="name">
        {{name.value}}
      </template>
      <template slot="insertedAt" scope="insertedAt">
        <timeago :since="insertedAt.value" :auto-update="60" />
      </template>
      <template slot="updatedAt" scope="updatedAt">
        <timeago :since="updatedAt.value" :auto-update="60" />
      </template>
    </attribute-table>

    <h3>{{$t('fieldsets.content')}}</h3>
    <div
      v-html="legalText.body"
      class="uk-placeholder uk-background-muted"
    ></div>
  </div>
</template>

<script>
import UIkit from 'uikit';
import AttributeTable from '@/components/AttributeTable';
import CommonButton from '@/components/CommonButton';
import deleteLegalTextMutation from '@/api/mutations/delete-legal-text.graphql';
import Toast from '@/helpers/Toast';
import View from '@/mixins/View';

export default {
  name: 'legal-texts-show-view',
  mixins: [
    View,
  ],
  components: {
    AttributeTable,
    CommonButton,
  },
  props: {
    legalText: Object,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    isSuccessfullyLoaded() {
      return this.isLoaded && this.legalText;
    },
  },
  methods: {
    deleteLegalTextWhenConfirmed() {
      UIkit.modal
           .confirm(this.$t('confirmations.delete'))
           .then(() => { this.deleteLegalText(); })
           .catch(() => {});
    },
    async deleteLegalText() {
      await this.$apollo.mutate({
        mutation: deleteLegalTextMutation,
        variables: { id: this.id },
      });
      const message = this.$t('toasts.deleted');
      Toast.success(message);
      this.$router.push({ name: 'legal-texts' });
    },
  },
  i18n: {
    messages: {
      de: {
        confirmations: {
          delete: 'Rechtstext wirklich löschen?',
        },
        headlines: {
          attributes: 'Eigenschaften',
        },
        toasts: {
          deleted: 'Rechtstext wurde gelöscht',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ShowView.vue?319de24a